export const fmtMoney = (value, currency = "EUR") =>
    new Intl.NumberFormat("de-DE", { style: "currency", currency }).format(
        Number.isFinite(value) ? value : 0
    );

export const toNum = (value) => {
    const normalized = typeof value === "string" ? value.replace(",", ".") : value;
    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
};

export const emptyArtikel = () => ({
    id: "",
    articleNumber: "",
    name: "",
    description: "",
    hasAmount: false,
    amount: "",
    price: "",
    taxRate: 19,
    unit: "",
    currency: "EUR",
});

export const units = ["Stück", "Std", "m²", "m³", "lfd. Meter", "Liter", "Kilogramm"];
export const currencies = ["EUR", "CHF", "USD", "GBP"];
export const taxRates = [19, 7, 0];
